/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import React from 'react'
import Scheduled from './Scheduled/index'
import Unscheduled from './Unscheduled/index'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/TabContent/Content/AppointmentsList/Content/Appointment/Time"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventValueData = fromData.useDataFormat({ viewPath,
context: 'event',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Scheduled'}>
<Scheduled
  viewPath={`${viewPath}/Scheduled`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Unscheduled'}>
<Unscheduled
  viewPath={`${viewPath}/Unscheduled`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}